// models
import { Base } from 'app/shared/models/base.model';
import { RoleWebView } from 'app/shared/models/role-webview.model';
import { Customer } from 'app/shared/models/customer.model';
import { CustomerSector } from 'app/shared/models/customer-sector.model';

export class ContactCustomer extends Base {

  constructor(
    public Customer?: Customer,
    public CustomerSectorWebView?: CustomerSector,
    public Domain?: string,
    public Email?: string,
    public Name?: string,
    public PreferedLanguage?: string,
    public RoleWebView?: RoleWebView,
    public Token?: any,
    public ViewAllCustomerSectorsWebView?: boolean
  ) {
    super();
  }

  public static hasPermissions(permissions: ERoleActionWebview[], actionsPermissions: Array<ERoleActionWebview>): boolean {
    let hasPermission = false;
    permissions.forEach(p => hasPermission = this.hasPermission(p, actionsPermissions));
    return hasPermission;
  }

  public static hasPermission(permission: ERoleActionWebview, actionsPermissions: Array<ERoleActionWebview>): boolean {
    if (actionsPermissions == null) {
      return false;
    }
    if (actionsPermissions) {
      return actionsPermissions.includes(permission);
    }
  }
}

export enum ERoleActionWebview {
  CertificatesChangeStatus = 1,
  CertificatesDownload = 2,
  CertificatesList = 3,
  CertificatesView = 4,
  CertificatesViewSupplements = 5,
  CertificatesViewAttachments = 6,
  CertificatesViewCriterionAcceptance = 7,
  InstrumentsList = 8,
  InstrumentsViewAttachments = 9,
  InstrumentsViewCriterionAcceptance = 10,
  BudgetsList = 11,
  BudgetsView = 12,
  StandardsList = 13,
  StandardsView = 14,
  ReportsList = 15,
  ReportsView = 16
}



// WEBPACK FOOTER //
// ./src/app/shared/models/contact-customer.model.ts